module.exports = __webpack_public_path__ + "static/media/MeterReadPrizeDraw.d17619ee.pdf";